import { Component, OnInit, isDevMode } from '@angular/core';
import { environment } from '../environments/environment';
import { ApiConfig } from './shared/services/config/api.config';
import { AuthService } from './shared/services/auth.service';
import { UserService } from './shared/services/user.service';
import { SessionService } from './shared/services/session.service';
import { BeneficiaryService } from './shared/services/beneficiary.service';
import { ContractService } from './shared/services/contract.service';
import { SpecialtiesService } from './shared/services/specialties.service';
import { DoctorService } from './shared/services/doctor.service';
import { AppointmentService } from './shared/services/appointment.service';
import { AuthorizationService } from './shared/services/authorization.service';
import { VoucherAttachedService } from './shared/services/voucher-attached.service';
import { ListService } from './shared/services/list.service';
import { IpssService } from './shared/services/ipss.service';
import { ExamenService } from './shared/services/examen.service';
import { MedicalCenterService } from './shared/services/medical-center.service';
import { PaymentService } from './shared/services/payment.service';
import { CertificateService } from './shared/services/certificate.service';
import { CitieService } from './shared/services/citie.service';
import { InvoiceService } from './shared/services/invoice.service';
import { RegisterService } from './shared/services/register.service';
import { DocumentTypeService } from './shared/services/documenttype.service';
import { serviceClientService } from './shared/services/serviceClient.service';
import { BancosService } from './shared/services/bancos.service';
import { RefundService } from './shared/services/refund.service';
import { CoverageAbroadService } from './shared/services/coverage-abroad.service';
import { LaboratoryTestsService } from './shared/services/laboratory-tests.service';
import { ReintegrateService } from './shared/services/reintegrate.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ 
    ApiConfig,
    AuthService,
    UserService,
    SessionService,
    BeneficiaryService,
    SpecialtiesService,
    ContractService,
    DoctorService,
    AppointmentService,
    AuthorizationService,
    VoucherAttachedService,
    ListService,
    IpssService,
    ExamenService,
    MedicalCenterService,
    PaymentService,
    CertificateService,
    CitieService,
    InvoiceService,
    RegisterService,
    DocumentTypeService,
    serviceClientService,
    BancosService,
    RefundService,
    CoverageAbroadService,
    LaboratoryTestsService,
    ReintegrateService
  ]
})
export class AppComponent implements OnInit  {
  title = 'app';
 
  ngOnInit() {
    console.log('environment -> ' + environment.envName);
  }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts